// What a software policy rule says about a program: three switches, Install, Update and Remove. The same reading as the API's _policy/rules.py.

export const switchesOf = (rule) => {
  const r = rule || {};
  return { install: !!r.install, update: !!r.update, remove: !!r.remove };
};

// The rules in order of program name, ignoring case; a rule with no program yet goes last. order is 'asc' or 'desc'. A new array: the rules given are not changed.
export const sortRules = (rules, order = 'asc') => {
  const named = (r) => String((r && r.key) || '').trim().toLowerCase();
  const sign = order === 'desc' ? -1 : 1;
  return [...(rules || [])].sort((a, b) => {
    const x = named(a);
    const y = named(b);
    if (!x || !y) return x === y ? 0 : (x ? -1 : 1);
    return x < y ? -sign : x > y ? sign : 0;
  });
};

// What ticking or clearing one switch changes: Remove stands alone (ticking it clears Install and Update), and ticking Install or Update clears Remove.
export const tickSwitches = (name, on) => (name === 'remove' ? { install: false, update: false, remove: on } : { [name]: on, remove: false });

// The rule for a program (by its key, ignoring case), or undefined.
export const ruleFor = (rules, key) => {
  const want = String(key || '').trim().toLowerCase();
  return want ? (rules || []).find((r) => String((r && r.key) || '').trim().toLowerCase() === want) : undefined;
};

// The rules with this program's rule changed by `patch`; a program with no rule yet gets one (everything off, enabled) with the patch on it. A new array.
export const withRule = (rules, key, patch) => {
  const list = rules || [];
  if (!ruleFor(list, key)) return [...list, { ...emptyRule(), key, ...patch }];
  const want = String(key).trim().toLowerCase();
  return list.map((r) => (String((r && r.key) || '').trim().toLowerCase() === want ? { ...r, ...patch } : r));
};

// The policy's filter as the API's "label=value;label=value" text (pairs with a blank label or value are left out).
export const filterQuery = (filter) => (filter || []).filter((f) => f && String(f.label || '').trim() && String(f.value || '').trim())
  .map((f) => `${String(f.label).trim()}=${String(f.value).trim()}`).join(';');

export const emptyRule = () => ({ key: '', install: false, update: false, remove: false, enabled: true });

// The rule in words: 'install, update', 'remove' or 'report only'.
export const ruleText = (rule) => {
  const on = switchesOf(rule);
  const names = ['install', 'update', 'remove'].filter((name) => on[name]);
  return names.length ? names.join(', ') : 'report only';
};
